import React, { useEffect, useRef } from "react";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import { tradeInAemModelSelectSetModelId } from "../../../redux/actions/TradeInAemModelSelectActions";
import { TradeInAemLabel, useTradeInAemLabel } from "../../../utils/labels";
import * as Styles from "./styles/ModelSelect";
import { ImageFluid } from "../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { TradeInAemModelSelectType } from "../../../utils/constants";
import { getFilteredModelList, getModelImage } from "../../../utils/utils";
import { getInternalLink } from "../../../utils/navUtils";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import * as Type from "../../../../common-deprecated/styles/v2/toyota/globals/Type";
import TradeInAemModelPrice from "./price/TradeInAemModelPrice";
import { tradeInAemUpdateExtraInfoProp } from "../../../redux/actions/TradeInAemVehicleActions";
import { useDispatch } from "../../../../shared-logic/redux/store";

const TradeInAemModelSelectList = (): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const csl = useTradeInCsl();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const selectedCarType = useTradeInAemSelector((state) => state.tradeInAemModelSelect.selectedCarType);
    const modelList = useTradeInAemSelector((state) => state.tradeInAemModelSelect.modelList);
    const modelCodes = useTradeInAemSelector(({ tradeInAemSettings }) =>
        selectedCarType === TradeInAemModelSelectType.New
            ? tradeInAemSettings.newModelList
            : tradeInAemSettings.stockModelList,
    );
    const selectLabel = useTradeInAemLabel("tradeInAemModelSelectSelect");
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");
    // Create list of models based on provided modelCodes.
    const filteredModelList = getFilteredModelList(modelList, modelCodes);

    // After a user clicks on the button, the page will scroll down to the list of car results
    const resultRef = useRef<HTMLDivElement>(null);
    useEffect(() => resultRef.current?.scrollIntoView({ behavior: "smooth" }), [resultRef]);

    return (
        <Styles.Results ref={resultRef}>
            <Styles.ResultsTitle>
                <Type.H4>
                    <TradeInAemLabel label="tradeInAemModelSelectSelectModel" />
                </Type.H4>
            </Styles.ResultsTitle>
            <Styles.ModelGrid>
                {filteredModelList.map((model) => {
                    const ccisImage = getModelImage(model, commonSettings, {
                        type: "png",
                        bgColour: "",
                        width: 400,
                        height: 160,
                        padding: "0,0,0,0",
                        scaleMode: 1,
                    });
                    return (
                        <Styles.ModelCard key={model.id}>
                            <ImageFluid src={ccisImage} />
                            <Styles.ModelTitle>{model.name}</Styles.ModelTitle>
                            <TradeInAemModelPrice model={model} />
                            <Button.Primary
                                m={0}
                                width="100%"
                                type="button"
                                onClick={(event) => {
                                    dispatch(tradeInAemModelSelectSetModelId(model.id));
                                    dispatch(tradeInAemUpdateExtraInfoProp("selectedModelId", model.id));
                                    if (nextStep.onClick) nextStep.onClick(event);
                                }}
                            >
                                <Text.Button>{selectLabel}</Text.Button>
                            </Button.Primary>
                        </Styles.ModelCard>
                    );
                })}
            </Styles.ModelGrid>
        </Styles.Results>
    );
};

export default TradeInAemModelSelectList;
